import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';
import { DocumentType } from '@/model/document';
import MediaView from '@/components/disposable/MediaView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnlyfansDetailView',
  setup(__props) {

const route = useRoute();
const actorID = route.params.actorID as string;
const documentUUID = route.params.documentUUID as string;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MediaView, {
    documentUUID: _unref(documentUUID),
    redirectURL: `/${_unref(DocumentType).Onlyfans}/${_unref(actorID)}`
  }, null, 8, ["documentUUID", "redirectURL"]))
}
}

})